import "./Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGooglePlay,
  FaApple
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-top">

        {/* Company */}

        <div className="footer-col company">

          <img
            src="/Krivaonelogo1.png"
            alt="Logo"
            className="footer-logo"
          />

          <p>
            Find trusted local businesses near you.
            Search verified service providers,
            compare, connect and grow with confidence.
          </p>

          <div className="footer-social">

            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaYoutube /></a>

          </div>

        </div>

        {/* Quick Links */}

        <div className="footer-col">

          <h4>Quick Links</h4>

          <ul>

            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/blogs">Blogs</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms">Terms & Conditions</a></li>

          </ul>

        </div>

        {/* Categories */}

        <div className="footer-col">

          <h4>Popular Categories</h4>

          <ul>

            <li>Electricians</li>
            <li>Plumbers</li>
            <li>Doctors</li>
            <li>Restaurants</li>
            <li>Real Estate</li>
            <li>Beauty Salon</li>

          </ul>

        </div>

        {/* Cities */}

        

        {/* Contact */}

        <div className="footer-col">

          <h4>Contact Us</h4>

          <div className="footer-contact">

            <p>
              <FaMapMarkerAlt />
             Office No:2 Floor No:1st, Madhur Preet Building, Bhekrai Nagar, Phursungi 412308, Pune Saswad Road.
            </p>

            <p>
              <FaPhoneAlt />
            +91 774490 6313 <br/> +91 703089 8428
            </p>

            <p>
              <FaEnvelope />
              sales@krivaone.com
            </p>

          </div>

          {/* <div className="footer-app">

            <button>
              <FaGooglePlay />
              Google Play
            </button>

            <button>
              <FaApple />
              App Store
            </button>

          </div> */}

        </div>

      </div>

      <div className="footer-bottom">

        © {new Date().getFullYear()}
        &nbsp; Kriva Bharat Private Limited.
        All Rights Reserved.

      </div>

    </footer>
  );
}